module.exports = __webpack_public_path__ + "img/banner-kale.d4da4ac.webp";